import { Injectable } from '@angular/core';
import { ACTIVITIES_STYLES, ActivitiesCategory } from '@shared/enums/activities.enum';

/**
 * @title Activities Category Service
 * @since 1.0.0
 *
 * @description This service provides methods to get the style associated with a specific activity category.
 * It uses the ACTIVITIES_STYLES constant to map categories to their respective styles.
 *
 */
@Injectable({
	providedIn: 'root'
})
export class ActivitiesCategoryService {
	getCategoryStyle(category: ActivitiesCategory) {
		return ACTIVITIES_STYLES[category] || { color: 'black', icon: 'exclamationmark' };
	}
}
